import { Component, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToastBaseComponent, ToastData } from '../toast.type';

@Component({
  selector: 'red-success-toast',
  templateUrl: './success-toast.component.html',
  styleUrls: ['./success-toast.component.scss'],
})
export class SuccessToastComponent implements ToastBaseComponent {
  public data: ToastData = inject(MAT_SNACK_BAR_DATA);

  constructor(public snackBarRef: MatSnackBarRef<SuccessToastComponent>) {}
}
